import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Users, Getters, Mutations, Actions } from '@/models/User.model';

// Inital state
const state: Users = {
  loggedInUser: {
    loggedIn: false,
    // Logged In User Info
    displayName: '',
    lastLogin: '',
    // Linked Customer Info
    customerId: 0,
    customerStatusId: 0,
    industryId: 0,
    packageTypeId: 0,
    companyName: '',
  },
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Users> = {
  loggedInUser: (state) => state.loggedInUser,
  loggedInUserDisplayName: (state) => (state.loggedInUser.displayName.length > 0 ?  state.loggedInUser.displayName : 'Error: Contact Support').toUpperCase(),
  loggedInUserCompanyName: (state) => (state.loggedInUser.companyName.length > 0 ?  state.loggedInUser.companyName : 'Error: Contact Support').toUpperCase(),

  displayServiceProviderMenuItem: (state) => {
    if (state.loggedInUser.loggedIn) {
      // only show for Accommodation & Restaurant users
      if (state.loggedInUser.industryId < 3) {
        return true;
      }      
    }
    return false;
  },
};

// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Users> = {
  resetLoggedInUser(state) {
    state.loggedInUser = {
      loggedIn: false,
      // Logged In User Info
      displayName: '',
      lastLogin: '',
      // Linked Customer Info
      customerId: 0,
      customerStatusId: 0,
      industryId: 0,
      packageTypeId: 0,
      companyName: '',
    };
  },

  setLoggedInUser(state, { loggedInUser }) {
    state.loggedInUser = loggedInUser;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Users, Mutations, Getters> = {
  resetLoggedInUser({ commit }, payload) {
    commit('resetLoggedInUser', payload);
  },

  setLoggedInUser({ commit }, payload) {
    commit('setLoggedInUser', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Users, Getters, Mutations, Actions>('UserModule');

export const UserModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
